const singleBold = 'ExpensifyNeue-Regular';
const multiBold = 'ExpensifyNeue-Regular, Segoe UI Emoji, Noto Color Emoji';

export {singleBold, multiBold};
